import { array, date, number, object, string } from '@/core/utils/validation';
// TODO: to delete redundant comments later
const taskSchema = object({
    id: number().integer().positive().required(),
    // createDate: date()
    // 	.transform((value) => new Date(value))
    // 	.required(),
    createDate: date()
        // .defined()
        // .transform((value) => new Date(value))
        // .nonNullable()
        .required(),
    stockName: string().required(),
    quantity: number().integer().required(),
    pickedQuantity: number().integer().required(),
    blockedQuantity: number().integer().required(),
}).noUnknown(true);
const pickingItemSchema = object({
    id: number().integer().positive().required(),
    // stockName: string().required(),
    // TODO: remove this, probably it is not used
    locationId: number().integer().positive().required(),
    brand: string().required(),
    name: string().required(),
    article: string().required(),
    quantity: number().integer().required(),
    pickedQuantity: number().integer().required(),
    blockedQuantity: number().integer().required(),
    cellName: string().required(),
}).noUnknown(true);
const blockedItemSchema = object({
    id: number().integer().positive().required(),
    stockId: number().integer().positive().required(),
    stockName: string().required(),
    pickingTask: object({
        id: number().integer().positive().required(),
        createDate: date().required(),
    })
        .nullable()
        .defined(),
    // TODO: add TrackableStatus model value check?
    trackableStatus: number().integer().required(),
    createDate: date()
        // .transform((value) => new Date(value))
        .required(),
    // warehouseman: string().nullable().required(), // TODO: check
    warehouseman: string().nullable().defined(), // TODO: check
    brand: string().required(),
    name: string().required(),
    article: string().required(),
    cellId: number().integer().positive().required(),
    cellName: string().required(),
    quantity: number().integer().required(),
    // reason: BlockReason;
    // TODO: add BlockReason model value check?
    reason: number().integer().required(),
});
const stockInvoiceSchema = object({
    stockInvoiceId: number().integer().positive().required(),
    stockName: string().required(),
    invoiceNum: string().required(),
    invoiceDate: date().required(),
    uploadDate: date().required(),
    quantity: number().integer().positive().required(),
    receiptedQuantity: number().integer().min(0).required(),
    // TODO: add TrackableStatus model value check?
    trackableStatus: number().integer().required(),
});
const blockedItemIdsSchema = array().of(number().integer().positive().required());
export { blockedItemIdsSchema, blockedItemSchema, pickingItemSchema, stockInvoiceSchema, taskSchema };
